<template>
  <div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <div class="select">
            <select v-model="extra.mosaic">
              <option :value="null">全部</option>
              <option :value="true">有码</option>
              <option :value="false">无码</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column">
        <AddButton
          :placeholder="'Find by actor name'"
          :fieldName="'actor'"
          :onClick="addToListField"
        />
      </div>
      <div class="column">
        <AddButton
          :placeholder="'Find by genre type'"
          :fieldName="'genre'"
          :onClick="addToListField"
        />
      </div>
      <div class="column">
        <div class="field">
          <div class="control">
            <input
              class="input"
              type="number"
              min="-1"
              placeholder="Min links"
              v-model="extra.links"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <button class="button" @click="commit()">提交</button>
      </div>
    </div>
    <QueryPreview :query="extra" />
    <FlowBoard flowSource="/api/v1/jav/film/" :query="$route.query" :card="card" :key="'film'" />
  </div>
</template>

<script>
import FlowBoard from "./FlowBoard";
import Card from "./FilmCard";
import QueryPreview from "./QueryPreview";

var AddButton = {
  props: {
    placeholder: { type: String, required: true },
    fieldName: { type: String, required: true },
    onClick: { type: Function, required: true }
  },
  data: function() {
    return {
      value: null
    };
  },
  template: `
  <div class="field has-addons">
    <div class="control">
      <input class="input" type="text" :placeholder="placeholder" v-model="value"/>
    </div>
    <div class="control">
      <a class="button" @click="onClick(value, fieldName); value = null;" :disabled="!value">
        <span class="icon">
          <i class="fas fa-plus"></i>
        </span>
      </a>
    </div>
  </div>
	`
};

export default {
  name: "FilmBoard",
  components: {
    FlowBoard,
    QueryPreview,
    AddButton
  },
  props: {},
  data() {
    return {
      extra: {},
      card: Card
    };
  },
  activated: function() {
    this.extra = JSON.parse(JSON.stringify(this.$route.query));
  },
  methods: {
    commit: function() {
      this.$router.replace({ query: this.extra });
    },
    addToListField: function(value, key) {
      if (value) {
        if (this.extra[key] == null) {
          this.$set(this.extra, key, value);
        } else {
          if (!Array.isArray(this.extra[key])) {
            this.extra[key] = [this.extra[key]];
          }
          this.extra[key].push(value);
        }
      }
    }
  }
};
</script>

<style scoped>
</style>
